
export enum VoteTypes {
    DisableKarma,
    TogglePause,
}
